var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.53 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9e4db6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M752.69,370.87a73.1,73.1,0,0,1,1.38,13.32,76.1,76.1,0,1,1-76.1-76.1,75.39,75.39,0,0,1,40.91,12.06l2.81-2.82A79.27,79.27,0,0,0,678,304.19a80,80,0,1,0,80,80,77.83,77.83,0,0,0-2-16.62Z",
    transform: "translate(-597.97 -304.19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.49,430.32a10.9,10.9,0,0,1-7.58-3.08l-47-47.1a10.68,10.68,0,0,1,0-15l12.84-12.85a10.66,10.66,0,0,1,7.55-3.18,11,11,0,0,1,7.65,3.17l26.59,26.67,60.82-61.12a10.63,10.63,0,0,1,7.52-3.1H744a10.83,10.83,0,0,1,7.59,3.08l12.86,12.86a10.85,10.85,0,0,1,.49,14.67v.05l-.49.56-81.3,81.31A10.92,10.92,0,0,1,675.49,430.32ZM743.89,318",
    transform: "translate(-597.97 -304.19)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGraphic);
export default __webpack_public_path__ + "static/media/tick-graphic.1b24ed3bada0447ffb4b46037b348f66.svg";
export { ForwardRef as ReactComponent };